import { z } from 'zod'

import { SerializedBusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const SmartSegmentNotFoundSchema = SerializedBusinessErrorSchema.extend({
  field: z.literal('smart_segment_id'),
  original_message: z.literal('Segment not found'),
})

export const SmartSegmentFilterValidationErrorSchema = SerializedBusinessErrorSchema.extend({
  field: z.literal('filter'),
})

export const SmartSegmentTitleValidationErrorSchema = SerializedBusinessErrorSchema.extend({
  field: z.literal('title'),
})
